const getElectron = () => {
  if (window.isElectron) {
    if (window.nodeRequire) {
      return window.nodeRequire('electron');
    }
    if (window.require) {
      return window.require('electron');
    }
  }
  return null;
};
export default getElectron();
